<template lang="html">
  <div class="overlayt" >
    <div class="popupt" >

      <div class="term" @click="preventClose">
        <h2 style="text-align:center">Pravila privatnosti</h2>
        <br>
      </div>
      <button type="button" name="button" @click="close($event)">Close</button>
      <div class="pol" @click="preventClose">

<h2>Politika privatnosti</h2>
<br>
<p>U preduzeću Virginia d.o.o. veoma cenimo Vašu privatnost i zato o Vašim podacima izuzetno pažljivo brinemo. Sve posredovane informacije su sigurne i nećemo ih ni pod kojim uslovima ustupati trećem licu, što Vam osigurava potpuno sigurno i bezbedno poslovanje i saradnju sa preduzećem Virginia d.o.o.</p>
<br>
<p>Da bismo uspešno obradili Vašu narudžbinu potrebni su nam Vaše ime i prezime, adresa, e-mail adresa i broj telefona. Uz pomoć tih podataka bićemo u mogućnosti da Vam isporučimo željeni proizvod, kao i da Vas obavestimo o trenutnom statusu narudžbine.</p>
<br>
<p>Preduzeće Virginia d.o.o. će Vaše lične podatke koristiti isključivo u svrhe tehničke administracije web sajta, kako bi vam dala pristup posebnim informacijama ili za komunikaciju sa vama. Preduzeće Virginia d.o.o. neće predati ili prodati podatke koje poseduje trećim licima, osim kurirskoj službi Aks radi lakše komunikacije u vezi sa isporukom proizvoda.</p>
<br>
<p>Zaposleni u preduzeću Virginia d.o.o. su obavezni da poštuju poverljivost Vaših podataka. Nikada i ni na koji način nećemo zloupotrebiti Vaše privatne informacije.</p>
<br>
<p>Korišćenje naših servisa podrazumeva saglasnost korisnika sa navedenim uslovima korišćenja.</p>
<br>
<h2>Plaćanje</h2>
<br>
<p>Plaćanje je moguće izvršiti isključivo pouzećem, odnosno gotovinski u trenutku isporuke. U obavezi ste da proizvod koji Vam bude dostavljen na adresu, platite kuriru na licu mesta. Za više informacija, molim pogledajte stranicu USLOVI ISPORUKE.</p>
<br>
<h2>Pravo na odustajanje/Povraćaj robe </h2>
<br>
<p>Prema Zakonu o zaštiti potrošača kupovina preko naše internet stranice www.virginia.rs smatra se prodajom na daljinu.</p>
<br>
<p>Na osnovu odredbi ovog Zakona, kupac ima pravo da odustanete od kupovine proizvoda u roku od 14 dana od dana kada Vam je proizvod predat. Prilikom odustanka kupac može, ali ne mora da navede razloge zbog kojih odustaje. U slučaju odustanka, kupac ima pravo na povrat novca ili na zamenu za drugi proizvod. Cena se kupcu vraća po prijemu proizvoda, i nakon što se utvrdi da je proizvod neoštećen i ispravan.</p>
<br>
<p>Kupac je u obavezi da izjavu o odustanku od ugovora pošalje na e-mail adresu office@virginia.rs sa svim podacima vezano za povrat novca.</p>
<br>
<p>Kupac je dužan da proizvod vrati bez odlaganja, a najkasnije u roku od 14 dana od dana kada je poslao izjavu o odustanku. Po isteku roka od 14 dana od dana kada je poslao izjavu, proizvod se više ne moze vratiti.</p>
<br>
<p>Prilikom povrata robe obavezno je vratiti u ispravnom i nekorišćenom stanju i originalno neoštećenom pakovanju, pri čemu se mora priložiti račun koju je kupac prethodno dobio uz porudžbinu.</p>
<br>
<p>Po prijemu proizvoda, utvrdiće se da li je proizvod ispravan i neoštećen. Kupac odgovara za neispravnost ili oštećenje proizvoda koji su rezultat neadekvatnog rukovanja proizvodom, tj. kupac je isključivo odgovoran za umanjenu vrednost proizvoda koja nastane kao posledica rukovanja robom na način koji nije adekvatan, odnosno prevazilazi ono što je neophodno da bi se ustanovili njegova priroda, karakteristike i funkcionalnost. Ukoliko se utvrdi da je nastupila neispravnost ili oštećenje proizvoda krivicom kupca, odbiće se vraćanje novca i proizvod će mu biti vraćen o njegovom trošku.</p>
<br>
<p>Preduzeće Virginia d.o.o. je dužano da kupcu bez odlaganja vrati iznos koji je platio po osnovu ugovora, a najkasnije u roku od 14 dana od dana prijema izjave o odustanku, a nakon prijema proizvoda. Troškove vraćanja proizvoda i novca – direktne troškove, snosi kupac, sem u slučajevima kada kupac dobije neispravan ili pogrešan proizvod. Kupac plaća iznos poštarine po zvaničnom cenovniku kurirske službe Aks.</p>
<br>
</div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  data(){
    return{


    }
  },
  computed:{
    ...mapGetters([
        'showprava'

    ]),


  },
  methods:{
    close(e){
      this.setprava(!this.showprava);
        e.stopPropagation()
    },
    preventClose (e) {
        			e.stopPropagation()
        		},
            ...mapMutations([

              'setprava'
          ]),
  },

  mounted(){


  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/prava.vue